import styles from "./checkoutReviewVendorOrderSection.module.scss";
import { VendorDeliveryDates } from "@/fetch/getCheckoutResponse";
import { CheckoutReviewVendorOrderSectionProps } from "@/app/checkout/(squeeze)/review/checkoutReviewVendorOrderSection";
import moment from "moment";

export default function CheckoutReviewVendorOrderSectionHeader({
  shoppingCartVendorOrder,
}: CheckoutReviewVendorOrderSectionProps) {
  const vendorDeliveryDates = shoppingCartVendorOrder.vendorDeliveryDates as VendorDeliveryDates;
  const renderEstimatedDeliveryDate = () => {
    const fromDate = moment(vendorDeliveryDates.fromDate);
    const toDate = moment(vendorDeliveryDates.toDate);
    if (fromDate.isSame(toDate, "day")) {
      return <span>{fromDate.format("MMMM D, YYYY")}</span>;
    }
    // Split the range into two non-breaking parts so it wraps between the two
    // dates on narrow (XS) screens instead of overflowing the card.
    return (
      <>
        <span>{fromDate.format("MMMM D, YYYY")} -</span> <span>{toDate.format("MMMM D, YYYY")}</span>
      </>
    );
  };

  return (
    <div className={styles.header}>
      <div className={styles.headerRow}>
        <div>
          <span className={styles.vendorName}>{shoppingCartVendorOrder.vendorName}</span>
        </div>
        <div>
          <p className={styles.deliveryText}>
            <span>Estimated Delivery:</span> {renderEstimatedDeliveryDate()}
          </p>
        </div>
      </div>
    </div>
  );
}
